import { COLORS } from "./colors";
import { SHADOWS } from "./shadows";

export default { ...COLORS, ...SHADOWS };
